import { assertNever } from "../assert-never";
import type { ColorItem } from "./color-theme/color-item";
import type { ColorValue } from "./color-value";
import { cssStringToColor } from "./css-string-to-color";

const getColorValue = (color: ColorItem): ColorValue | undefined => {
    if (typeof color === "undefined") return undefined;
    if (typeof color === "string") return cssStringToColor(color).value;
    if (color._type === "COLOR_STRING")
        return cssStringToColor(color.asString).value;
    if (color._type === "COLOR") return color.value;
    if (color._type === "COLOR_SET") return color.main.value;
    if (color._type === "COLOR_VALUE") return color;
    assertNever(color);
};

export { getColorValue };
